import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { createLicenseVerifier } from './domain/license.js';
import { ProjectStore } from './domain/store.js';
import { ExportRegistry } from './exports/registry.js';
import { registerExportGenerators } from './exports/register.js';
import { IdbProjectStorage } from './persistence/idb.js';
import { App } from './ui/App.js';
import { InProcessClient, WorkerPoolClient } from './worker/client.js';
import type { ComputeApi } from './worker/protocol.js';
import './styles.css';

const exportRegistry = new ExportRegistry();
registerExportGenerators(exportRegistry);

let compute: ComputeApi;
try {
  compute = new WorkerPoolClient();
} catch {
  // Workers unavailable (very old browser, embedded webview): the
  // same handler runs in-process rather than not at all.
  compute = new InProcessClient();
}

const store = new ProjectStore({
  compute,
  storage: new IdbProjectStorage(),
  verifier: createLicenseVerifier(),
  exports: exportRegistry,
});

// Restore the autosaved project and any remembered license.
void store.restore();

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('Missing #root element');
createRoot(rootElement).render(
  <StrictMode>
    <App store={store} />
  </StrictMode>,
);
